'use client'

import React, { useEffect, useRef, useState } from 'react'

interface Props {
    children: React.ReactNode
    threshold?: number
    delay?: number
}

const PetCareScrollAnimation = ({ children, threshold = 0.1, delay = 0 }: Props) => {
    const ref = useRef<HTMLDivElement>(null)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        setIsVisible(true)
                    }, delay)
                    observer.unobserve(entry.target)
                }
            },
            {
                threshold,
                rootMargin: '0px 0px -50px 0px'
            }
        )

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current)
            }
        }
    }, [threshold, delay])

    return (
        <div
            ref={ref}
            className={`transition-all duration-700 ease-out ${
                isVisible
                    ? 'opacity-100 transform translate-y-0'
                    : 'opacity-0 transform translate-y-8'
            }`}
            style={{
                transitionDelay: isVisible ? '0.2s' : '0s'
            }}
        >
            {children}
        </div>
    )
}

export default PetCareScrollAnimation